import styled from "styled-components";

export const ListHeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #00032aed;
  /* background-color: #002300ff; */
  color: white;
  padding: 10px;

  span {
    display: flex;
    font-size: 12px;
    gap: 5px;
    align-items: center;
  }
`;
